import React from 'react'

export const renderRichText = (value, tagName, props = {}) => {
  return typeof value === 'string'
    ? React.createElement(tagName, {
        ...props,
        dangerouslySetInnerHTML: { __html: value },
      })
    : value
}
